import { render, staticRenderFns } from "./create-settlement-bak.vue?vue&type=template&id=37532227&scoped=true"
import script from "./create-settlement-bak.vue?vue&type=script&lang=js"
export * from "./create-settlement-bak.vue?vue&type=script&lang=js"
import style0 from "./create-settlement-bak.vue?vue&type=style&index=0&id=37532227&prod&lang=scss&scoped=true"
import style1 from "./create-settlement-bak.vue?vue&type=style&index=1&id=37532227&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37532227",
  null
  
)

export default component.exports